import { atom } from "recoil";

export const sideBarState = atom({
  key: "side-bar",
  default: {
    toggle: false,
  },
});
